module.exports = __webpack_public_path__ + "static/media/overpass-thin-italic.a452cd38.eot";